import { ModuleDependencyType } from 'module/model/module-dependency.type';

export interface IModuleDependency {
	readonly moduleId: string;
	readonly dependencyId: string;
	readonly type: ModuleDependencyType;
}

export class ModuleDependency {
	private _moduleId: string;
	private _dependencyId: string;
	private _type: ModuleDependencyType;

	constructor(
		moduleId: string,
		dependencyId: string,
		type: ModuleDependencyType
	) {
		this._moduleId = moduleId;
		this._dependencyId = dependencyId;
		this._type = type;
	}

	get moduleId(): string {
		return this._moduleId;
	}

	get dependencyId(): string {
		return this._dependencyId;
	}

	get type(): ModuleDependencyType {
		return this._type;
	}
}
